import { render, staticRenderFns } from "./skillsTab.vue?vue&type=template&id=ba2bbbc2&"
import script from "./skillsTab.vue?vue&type=script&lang=js&"
export * from "./skillsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports